const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1'])

export function isLocalCheckoutOrigin(origin: string): boolean {
  try {
    const url = new URL(origin)
    return LOCAL_HOSTS.has(url.hostname.toLowerCase())
  } catch {
    return false
  }
}

/** Browser origin for share links and 3DS returns. Never points at production from localhost. */
export function clientCheckoutOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '')
  }
  return 'https://app.tago.rent'
}

/**
 * Path to resume after a hosted checkout hop. Native has no `window.location`,
 * so callers must not read `.pathname` raw (TAGO-MOBILE-48 was `.origin` on
 * the same undefined `location`).
 */
export function optionalClientCheckoutReturnPath(): string | undefined {
  if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') {
    const path = window.location.pathname.trim()
    if (path.startsWith('/')) return path
  }
  return undefined
}

/** Origin only when the runtime is a real browser; native omits the field. */
export function optionalClientCheckoutOrigin(): string | undefined {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '')
  }
  return undefined
}

export function splitSharePath(token: string): string {
  return `/split/${encodeURIComponent(token)}`
}

export function splitShareUrl(token: string, origin = clientCheckoutOrigin()): string {
  return `${origin.replace(/\/$/, '')}${splitSharePath(token)}`
}
